import { render, staticRenderFns } from "./CTAType2.vue?vue&type=template&id=31f7e3b6&scoped=true"
import script from "./CTAType2.vue?vue&type=script&lang=js"
export * from "./CTAType2.vue?vue&type=script&lang=js"
import style0 from "./CTAType2.vue?vue&type=style&index=0&id=31f7e3b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f7e3b6",
  null
  
)

export default component.exports